import React from 'react';

import styled from 'styled-components';

import Popover from 'components/lib/Popover';
import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { useAppSelector } from 'store/hook';
import { CommunityType } from 'types/communities';
import { formatDistanceFromKm, getDistanceUnitLabel } from 'utils/helpers/units';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Name = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
  margin-top: 2px;
`;

const Address = styled.div`
  font-family: var(--font-regular);
  font-size: 10px;
  color: var(--text-primary);
  opacity: 0.5;
  padding-left: 3px;
  gap: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 5px;
`;

const CommunityColor = styled.div<ColorProps>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  background-color: ${(props) => `${props.color}`};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 2px #fff;
  border-radius: 50%;
`;

type Props = {
  community: CommunityType;
};

type ColorProps = {
  color: string;
};

const MapInfoPanelItem = ({ community }: Props) => {
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const isCompetitor = community.company_relation_type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR;
  const distance = selectedCommunity && community.distances && community.distances[selectedCommunity.id];
  const hasDistance = distance !== null && distance !== undefined;
  const hasUnitSource = (value: any) => Boolean(value?.unit_system || value?.preferences?.unit_system);
  const unitSource = hasUnitSource(selectedCommunity) ? selectedCommunity : community;
  const distanceUnit = getDistanceUnitLabel(unitSource);

  return (
    <Item key={community.id}>
      <FlexContainer>
        <CommunityColor color={isCompetitor ? community.color : 'var(--text-primary)'} />
        <Name>{community.comunity_name}</Name>
      </FlexContainer>
      <Popover arrow={false} content={<Address>{community.address}</Address>}>
        <Address>
          {hasDistance && (
            <>
              <span>
                {formatDistanceFromKm(distance, unitSource, 2)} {distanceUnit}
              </span>
              <span> · </span>
            </>
          )}
          {community.address}
        </Address>
      </Popover>
    </Item>
  );
};

export default MapInfoPanelItem;
